module.exports = __webpack_public_path__ + "img/server_icon.b872b732.svg";